import { Location, TitleCasePipe } from "@angular/common";
import { Component, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { finalize } from "rxjs/operators";
import { AuthenticationService } from "../../../../core/authentication/authentication.service";
import { LoadingService } from "../../../../core/loader/loading.service";
import { DynamicFormComponent } from "../../../../shared/components/dynamic-form/dynamic-form.component";
import { QuestionBase } from "../../../../shared/components/dynamic-form/question-base";
import { NotificationService } from "../../../../shared/components/notification/notification.service";
import { AnyObject } from "../../../../shared/types/app.type";
import { UserInfo } from "../../../../shared/types/user-info";
import { MaintenanceProviderService } from "../../maintenance-provider/maintenance-provider.service";
import { MaintenanceProvider } from "../../maintenance-provider/maintenance-provider.types";
import { PartnerService } from "../../partners/partner.service";
import { Partner } from "../../partners/partner.type";
import { QuoteService } from "../quote.service";
import { Quote } from "../quote.type";
import { CreateQuoteService } from "./create-quote.service";

@Component({
  selector: "app-create-quote",
  templateUrl: "./create-quote.component.html",
  styleUrls: ["./create-quote.component.css"],
  providers: [CreateQuoteService, TitleCasePipe],
})
export class CreateQuoteComponent implements OnInit {
  @ViewChild(DynamicFormComponent) dynamicForm: DynamicFormComponent;

  currentUser: UserInfo;
  questions: QuestionBase<string | boolean | number>[];
  maintenanceProviders: MaintenanceProvider[];
  partner: Partner;

  constructor(
    public location: Location,
    private router: Router,
    private loader: LoadingService,
    private quoteService: QuoteService,
    private notificationService: NotificationService,
    private questionsService: CreateQuoteService,
    private authenticationService: AuthenticationService,
    private maintenanceProviderService: MaintenanceProviderService,
    private partnerService: PartnerService,
  ) {
    this.currentUser = this.authenticationService.currentUserInfo;
  }

  ngOnInit(): void {
    this.loader.show();
    this.maintenanceProviderService.getMaintenanceProviders();
    this.questionsService.generateQuestions({}).subscribe((qs) => {
      this.questions = qs;
      this.loader.hide();
    });
  }

  goBack(): void {
    this.location.back();
  }

  async onChange(event: AnyObject): Promise<void> {
    if (event.key === "startDate") {
      this.dynamicForm.getQuestion("endDate").minDate = event.value;
    }
    if (event.key === "endDate") {
      this.dynamicForm.getQuestion("startDate").maxDate = event.value;
    }
    if (event.source?.id === "partnerId") {
      const partnerId = event.value;
      this.partner = await this.getPartner(partnerId);
    }
  }

  onSubmit(values: Quote): void {
    for (const propName in values) {
      if (values[propName] === "" || propName === "partnerId") {
        delete values[propName];
      }
    }
    this.quoteService
      .createQuote({
        ...values,
      })
      .pipe(finalize(() => this.dynamicForm.enable()))
      .subscribe(
        (quote: Quote) => {
          this.notificationService.success("Quote successfully created");
          this.router.navigate([`/quotes/${quote.id}`]);
        },
        (error) => {
          this.notificationService.error(error || "Could not create quote");
        },
      );
  }

  private async getPartner(id: string) {
    return this.partnerService.getPartner(id).toPromise();
  }
}
